import { render, staticRenderFns } from "./Oauth.vue?vue&type=template&id=256356de"
import script from "./Oauth.vue?vue&type=script&lang=js"
export * from "./Oauth.vue?vue&type=script&lang=js"
import style0 from "./Oauth.vue?vue&type=style&index=0&id=256356de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports